module.exports = __webpack_public_path__ + "img/landing_blue.40887f9e.jpg";